// @flow
import React from 'react';
import { fromNow, resizeImage } from 'lib/common';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import 'moment/locale/ko';
import './BrandCard.scss';

type Props = {
  id: string,
  thumbnail: string,
  username: string,
  title: string,
  body: string,
  date: string,
  brandUrl: string,
  urlSlug: string,
  oneColumn?: boolean,
};

const BrandCard = ({ thumbnail, title, body, brandUrl, urlSlug, oneColumn }: Props) => {
  const imgUrl = resizeImage(thumbnail, 400, 200);
  const link = `/products/tags/${brandUrl}`;
  
  return (
    <div className={cx('BrandCard', { 'one-column': oneColumn, empty: !thumbnail })}>
      <Link to={link} className="brand-card-link">
        <div className="brand-card-container">
          <div className="brand-image-wrapper">
            {thumbnail ? (
              <img src={imgUrl} alt={title} className="brand-image" />
            ) : (
              <div className="brand-image-placeholder">
                <span className="placeholder-icon" role="img" aria-label="브랜드 이미지">🏢</span>
              </div>
            )}
            <div className="brand-overlay">
              <div className="brand-overlay-content">
                <span className="view-products-text">제품 보기</span>
              </div>
            </div>
          </div>
          <div className="brand-content">
            <h3 className="brand-title">{title}</h3>
          </div>
        </div>
      </Link>
    </div>
  );
};

BrandCard.defaultProps = {
  oneColumn: false,
};

export default BrandCard;



// WEBPACK FOOTER //
// ./src/components/common/BrandCard/BrandCard.js